import axios from 'axios';
import * as types from './ActionTypes';
import { API_URL } from 'configs';
import { legacyHttpPaths } from 'pages/AppraisalManagment/constants/legacyApiKeys';

const loader = (label) => ({ type: types.SHOW_LOADER, common_loader_label: label });
const hideLoader = () => ({ type: types.HIDE_LOADER });

const snackbar = (msg, type = 'general_error') => ({
  type: types.SHOW_SNACKBAR,
  snackbar_notification: msg,
  snackbar_notification_type: type,
});

const handleError = (error, dispatch, validationType) => {
  const res = error?.response;
  if (res?.status === 422) {
    dispatch({ type: validationType, validation_error: res.data.errors });
  } else dispatch(snackbar(res?.data?.error || `${res?.status} ${res?.statusText}`));
};

const redirect = (type) => ({ type });

const fetchSuccess = (type, listKey) => (data) => ({
  type,
  [listKey]: data,
});

const getSuccess = (type) => (data, action) => ({
  type,
  record: data,
  actionType: action,
});

/** Laravel may return a bare array or { data: [...] } from apiResource / pagination. */
const normalizeSectionsListPayload = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (payload && Array.isArray(payload.data)) return payload.data;
  return [];
};

export const hideSectionValidationError = (feild_key) => ({
  type: types.HIDE_SECTIONS_FIELD_VALIDATION_ERROR,
  feild_key: feild_key,
});

export const fetchSections = (object_viewed_id = '') => (dispatch) => {
  dispatch({ type: types.SECTIONS_REQUEST });
  dispatch(loader());

  axios
    .get(`${API_URL}${legacyHttpPaths.sectionsList}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      params: {
        object_viewed_id: object_viewed_id,
      },
    })
    .then((res) => {
      dispatch(hideLoader());
      dispatch(
        fetchSuccess(types.SECTIONS_SUCCESS, 'sectionsList')(normalizeSectionsListPayload(res.data))
      );
    })
    .catch((err) => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.SECTIONS_VALIDATION_ERROR);
    });
};

export const getSectionById = (id, actionType) => (dispatch) => {
  dispatch({ type: types.SECTIONS_REQUEST });
  dispatch(loader());

  axios
    .get(`${API_URL}${legacyHttpPaths.sectionById(id)}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
    .then((res) => {
      dispatch(hideLoader());
      dispatch(getSuccess(types.SECTIONS_GET_SUCCESS)(res.data, actionType));
    })
    .catch((err) => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.SECTIONS_VALIDATION_ERROR);
    });
};

export const createOrUpdateSection = (data, method = 'POST') => (dispatch) => {
  dispatch({ type: types.SECTIONS_REQUEST });
  dispatch(loader());

  const url =
    method === 'POST'
      ? `${API_URL}${legacyHttpPaths.sectionsList}`
      : `${API_URL}${legacyHttpPaths.sectionById(data.id)}`;

  axios({
    url,
    method,
    data,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(() => {
      dispatch(hideLoader());
      dispatch(
        snackbar(
          `Section ${method === 'POST' ? 'created' : 'updated'} successfully`,
          'success'
        )
      );
      dispatch(redirect(types.SECTIONS_REDIRECT));
    })
    .catch((err) => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.SECTIONS_VALIDATION_ERROR);
    });
};

export const deleteSection = (id) => (dispatch) => {
  dispatch({ type: types.SECTIONS_REQUEST });
  dispatch(loader());

  axios
    .delete(`${API_URL}${legacyHttpPaths.sectionById(id)}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
    .then(() => {
      dispatch(hideLoader());
      dispatch(snackbar('Section deleted', 'success'));
      dispatch(redirect(types.SECTIONS_REDIRECT));
    })
    .catch((err) => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.SECTIONS_VALIDATION_ERROR);
    });
};
